import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
// import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
// import {
//     getIsProductCompareFull,
//     getProductCompareChecked,
// } from "@insite/client-framework/Store/Components/CompareProductsDrawer/CompareProductsDrawerSelectors";
import addProductToCompare from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/AddProductToCompare";
import removeProductFromCompare from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/RemoveProductFromCompare";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import Typography from "@insite/mobius/Typography/Typography";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CrossIcon from "@NA/Icons/CrossIcon";
import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import Button from "@insite/mobius/Button";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { Clickable, Hidden } from "@insite/mobius/index";
import { CoveoProductModel } from "@NA/Types/CoveoModel";
import CoveoProductImage from "./CoveoProductImage";
import { HasProductContext, withProductContext } from "@NA/Components/Coveo/Contexts/CoveoProductContext";
import { getProductCompareChecked } from "@NA/Utilities/CoveoUtilities";
import { getIsProductCompareFull } from "@insite/client-framework/Store/Components/CompareProductsDrawer/CompareProductsDrawerSelectors";

interface OwnProps {
    showImage: boolean;
    showCompare: boolean;
    extendedStyles?: ProductListProductImageStyles;
}

const mapStateToProps = (state: ApplicationState, props: HasProductContext) => ({
    settingsCollection: getSettingsCollection(state),
    productCompareChecked: getProductCompareChecked(state, props.coveoproductContext),
    isProductCompareFull: getIsProductCompareFull(state),
    isAuthenticated: state.context.session.isAuthenticated,
    view: state.pages.productList.view,
    productCompareItems: state.components.compareProductsDrawer.productsIds,
    productComparePageLink: getPageLinkByPageType(state, "ProductComparePage"),
});

const mapDispatchToProps = {
    addProductToCompare,
    removeProductFromCompare,
};

type Props = ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    OwnProps &
    HasProductContext;

export interface ProductListProductImageStyles {
    wrapper?: InjectableCss;
    productImage?: ProductImageStyles;
    compareCheckbox?: CheckboxPresentationProps;
    compareCheckboxStatic?: CheckboxPresentationProps;
    compareWarningPopup?: ModalPresentationProps;
    CompareButtonContainer?: InjectableCss;
}

export const productImageStyles: ProductListProductImageStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            position: relative;
            padding: 20px 0 ;
            align-items: center;
            img {
                padding: 0 10px;
            }
        `,
    },
    compareCheckbox: {
        css: css`
            align-self: center;
            padding-top: 0px;
            position: absolute;
            top: 0.5rem;
            right: 0;
            display: flex;
            flex-direction: row-reverse;
            margin-top: 4px;
            margin-right: 8px;
            
            label {
                margin-left: 0;
                margin-right: 8px;
            }
            span {
                box-sizing: border-box;
                min-width: 20px !important;
                border: 2px solid #DDDDDD !important;
                border-radius: 3px;
                height: 20px !important;
            }
        `,
    },
    compareCheckboxStatic: {
        css: css`
            display: flex;
            position: absolute;
            top: auto;
            bottom: 1rem;
            left: 4.5rem;
            padding-top: 0;
            align-self: center;
            flex-direction: row-reverse;
            label {
                margin-left: 0;
                margin-right: 10px;
            }
            span {
                box-sizing: border-box;
                min-width: 20px !important;
                border: 2px solid #DDDDDD !important
                border-radius: 3px;
                height: 20px !important; 
            }
            span[role=checkbox] {
                border: 1.5px solid #DDDDDD !important
            }
        `,
    },
    productImage: {
        image: {
            css: css`
                img {
                    min-width: 100%;
                }
            `,
        },
    },
    compareWarningPopup: {
        sizeVariant: "small",
        size: 600,
        closeButtonIconProps: {
            src: CrossIcon,
            size: 20,
        },
        cssOverrides: {
            modalContainer: css`
                > div {
                    box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.14);
                    border-radius: 7px;
                }
            `,
            modalTitle: css`
                border-bottom: 0;
                span {
                    font-size: 28px;
                    font-weight: bold;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #002856;
                    width: calc(100% - 35px);
                    display: inline-block;                    
                }
                button {
                    position: absolute;
                    top: 5px;
                    right: 15px;
                    border-radius: 0;
                    &:hover {
                        background: none;
                        border-color: transparent;
                    }
                    span {
                        width: 100%;
                    }
                }
            `,
            modalContent: css`
                padding: 0 30px 30px;
            `,
        },
    },
    CompareButtonContainer: {
        css: css`
            text-align: right;
            margin-top: 30px;
            a {
                display: inline-block;
            }
        `,
    },
};

const CoveoProductListProductImage: FC<Props> = ({
    coveoproductContext,
    showImage,
    showCompare,
    isProductCompareFull,
    settingsCollection,
    productCompareChecked,
    extendedStyles,
    addProductToCompare,
    removeProductFromCompare,
    isAuthenticated,
    view,
    productCompareItems,
    productComparePageLink,
}) => {
    const toasterContext = React.useContext(ToasterContext);
    const [styles] = useState(() => mergeToNew(productImageStyles, extendedStyles));
    const [maximumCompareReached, setMaximumCompareReached] = React.useState(false);

    const closePopup = () => {
        setMaximumCompareReached(false);
    };

    const handleChanged = (_: React.SyntheticEvent, value: boolean) => {
        if (value && productCompareItems.length >= 3) {
            setMaximumCompareReached(true);
        } else if (value) {
            addProductToCompare({ productId: coveoproductContext.coveoProduct.productId });
        } else {
            removeProductFromCompare({ productId: coveoproductContext.coveoProduct.productId });
        }
    };
    return (
        <>
            <StyledWrapper
                {...styles.wrapper}
                data-test-selector="productListProductImage"
                data-test-key={coveoproductContext.coveoProduct.productId}
            >
                {showImage && <CoveoProductImage extendedStyles={styles.productImage} product={coveoproductContext} sourceName="Product List" />}
            </StyledWrapper>
            <Hidden below="lg">
                {isAuthenticated && showCompare && settingsCollection.productSettings.enableProductComparisons && (
                    <Checkbox
                        {...(view === "Grid" ? styles.compareCheckbox : styles.compareCheckboxStatic)}
                        checked={productCompareChecked}
                        onChange={handleChanged}                    
                    >
                        {translate("Compare")}
                    </Checkbox>
                                   
                )}
            </Hidden>
            <Modal
                headline={<Typography>{siteMessage("ProductionCompare_MaximumItemsReached")}</Typography>}
                {...styles.compareWarningPopup}
                isOpen={maximumCompareReached}
                handleClose={closePopup}
            >
                <StyledWrapper>
                    <Typography>{translate(`Please 'Compare' or remove items.`)}</Typography>
                    <StyledWrapper {...styles.CompareButtonContainer}>
                        <Clickable href={productComparePageLink?.url}>
                            <Button>{translate("Compare")}</Button>
                        </Clickable>
                    </StyledWrapper>
                </StyledWrapper>
            </Modal>
        </>
    );
};

export default withProductContext(connect(mapStateToProps, mapDispatchToProps)(CoveoProductListProductImage));
